var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3455 32.2023V24.7551C11.4963 21.7942 6.17776 14.482 14.1111 7.99521C14.6524 7.55265 15.4493 7.89878 15.5361 8.59254L16.2274 14.1232C16.2588 14.3738 16.3906 14.6009 16.5926 14.7525L19.4415 16.8891C19.7725 17.1374 20.2276 17.1374 20.5586 16.8891L23.4074 14.7525C23.6094 14.6009 23.7412 14.3738 23.7726 14.1232L24.4639 8.59254C24.5507 7.89878 25.3476 7.55265 25.8889 7.99521C33.8222 14.482 28.5037 21.7942 24.6545 24.7551V32.2023",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceability);
export default __webpack_public_path__ + "static/media/Serviceability.904160ea5a6970fc0c787b7bca15f077.svg";
export { ForwardRef as ReactComponent };